/**
 * @generated SignedSource<<aab6f3fcaea389415d707f87749a72fe>>
 * @relayHash d5b3b486626d032523668447f933702e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 354c0b2036d906d7ae2e966f47ff191e75d1623b0c463a838a7bb5cb00d40947

import type { ConcreteRequest } from 'relay-runtime';
export type CreateContentInlineMutation$variables = {
  createdInContentId: string;
  spaceKey?: string | null | undefined;
};
export type CreateContentInlineMutation$data = {
  readonly createContentInline: {
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type CreateContentInlineMutation = {
  response: CreateContentInlineMutation$data;
  variables: CreateContentInlineMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "createdInContentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "createdInContentId",
            "variableName": "createdInContentId"
          },
          {
            "kind": "Variable",
            "name": "spaceKey",
            "variableName": "spaceKey"
          },
          {
            "kind": "Literal",
            "name": "type",
            "value": "database"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "createContentInline",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "CreateContentInlineMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateContentInlineMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d5b3b486626d032523668447f933702e",
    "id": "354c0b2036d906d7ae2e966f47ff191e75d1623b0c463a838a7bb5cb00d40947",
    "metadata": {},
    "name": "CreateContentInlineMutation",
    "operationKind": "mutation",
    "text": "mutation CreateContentInlineMutation($createdInContentId:ID!,$spaceKey:String){createContentInline(input:{createdInContentId:$createdInContentId,spaceKey:$spaceKey,type:\"database\"}){id}}"
  }
};
})();

(node as any).hash = "9d349e804d611298aa425de2f3bfd42a";

export default node;
